const THIRD_PARTY_LOGIN_PAYLOAD_STORAGE_KEY = 'wikibit.thirdPartyLoginPayload.v1'

const isThirdPartyLoginPayload = (payload: unknown): payload is Record<string, any> => {
  return payload !== null && typeof payload === 'object' && !Array.isArray(payload)
}

/**
 * 暂存第三方回调返回的登录数据，避免把 LoginToken 等完整 payload 放进 URL。
 */
export const writeThirdPartyLoginPayload = (payload: Record<string, any>) => {
  if (!import.meta.client) return false

  try {
    sessionStorage.setItem(THIRD_PARTY_LOGIN_PAYLOAD_STORAGE_KEY, JSON.stringify(payload))
    return true
  } catch {
    return false
  }
}

/**
 * 读取并清理第三方登录中间页的一次性 payload。
 */
export const takeThirdPartyLoginPayload = () => {
  if (!import.meta.client) return null

  try {
    const payload = sessionStorage.getItem(THIRD_PARTY_LOGIN_PAYLOAD_STORAGE_KEY)
    sessionStorage.removeItem(THIRD_PARTY_LOGIN_PAYLOAD_STORAGE_KEY)
    if (!payload) return null

    const parsedPayload: unknown = JSON.parse(payload)
    return isThirdPartyLoginPayload(parsedPayload) ? parsedPayload : null
  } catch {
    sessionStorage.removeItem(THIRD_PARTY_LOGIN_PAYLOAD_STORAGE_KEY)
    return null
  }
}
